import { MemberFragment_talentAgents } from '@frontend/app/queries/fragments/types/MemberFragment';
import { renderTokenCell } from '../TokenCell';

export const renderTalentAgentCell = (data: MemberFragment_talentAgents[]) => renderTokenCell(data, 'agentName');
